import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=435353fd&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"
import style0 from "./Alert.vue?vue&type=style&index=0&id=435353fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435353fd",
  null
  
)

export default component.exports